import { render, staticRenderFns } from "./CardTypeDetail.vue?vue&type=template&id=545637d8&scoped=true&lang=pug&"
import script from "./CardTypeDetail.vue?vue&type=script&lang=ts&"
export * from "./CardTypeDetail.vue?vue&type=script&lang=ts&"
import style0 from "./CardTypeDetail.vue?vue&type=style&index=0&id=545637d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545637d8",
  null
  
)

export default component.exports